(function () {
  'use strict';

  function init(root) {
    var section = root.querySelector('[data-product-finder]');
    if (!section || section.dataset.previewReady === 'true') return;
    section.dataset.previewReady = 'true';
    var active=section.querySelectorAll('[data-filter-form] input:checked').length;
    var count=section.querySelector('[data-finder-active]'); if(count)count.textContent=active?'('+active+')':'';
    var dialog = section.querySelector('[data-finder-dialog]');
    var open = section.querySelector('[data-finder-open]');
    var close = section.querySelector('[data-finder-close]');
    var previousOverflow = '';
    open?.addEventListener('click', function () { previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';dialog?.showModal(); });
    close?.addEventListener('click', function () { dialog?.close(); });
    dialog?.addEventListener('close', function () { document.documentElement.style.overflow=previousOverflow;open?.focus({preventScroll:true}); });
    dialog?.addEventListener('cancel', function (event) { event.preventDefault(); dialog.close(); });
    section.querySelectorAll('[data-finder-sort]').forEach(function (select) {
      select.addEventListener('change', function () {
        section.querySelectorAll('[data-filter-sort-input]').forEach(function (input) { input.value = select.value; });
        var form = section.querySelector('[data-filter-form]');
        if (form) form.submit();
        else {
          var target = new URL(window.location.href);
          target.searchParams.set('sort_by', select.value);
          target.searchParams.delete('page');
          window.location.assign(target.href);
        }
      });
    });
    section.querySelectorAll('[data-filter-form] input[type="checkbox"], [data-filter-form-mobile] input[type="checkbox"]').forEach(function (input) {
      input.addEventListener('change', function () {
        var form = input.closest('form');
        if (form && window.matchMedia('(min-width: 701px)').matches) form.submit();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
